import mod from "-!./Modal.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Modal.js?vue&type=script&lang=js&external"